// Fixed vendor category catalog. Mirror of backend/vendor_categories.py
// so we don't wait on the network to render the signup picker or the
// organizer browse filter. The backend response is still the source of
// truth — we hydrate from it whenever we can, but fall back to this
// list if the request hasn't landed yet.
import { useEffect, useState } from "react";
import api from "@/lib/api";

export const VENDOR_CATEGORIES = [
  { value: "food",          label: "Food" },
  { value: "crafts",        label: "Crafts" },
  { value: "performers",    label: "Performers" },
  { value: "games",         label: "Games" },
  { value: "kids",          label: "Kids" },
  { value: "adults_only",   label: "Adults only" },
  { value: "miscellaneous", label: "Miscellaneous" },
];

export const MIN_CATEGORIES = 2;
export const MAX_CATEGORIES = 3;

export const CATEGORY_LABEL = Object.fromEntries(
  VENDOR_CATEGORIES.map((c) => [c.value, c.label])
);

// Cache the server response across the app so a full page renders
// the picker instantly on subsequent loads.
let _cache = null;

export function useVendorCategories() {
  const [data, setData] = useState(() =>
    _cache || {
      categories: VENDOR_CATEGORIES,
      min: MIN_CATEGORIES,
      max: MAX_CATEGORIES,
    }
  );
  useEffect(() => {
    if (_cache) return;
    let alive = true;
    api
      .get("/vendor-categories")
      .then(({ data: d }) => {
        _cache = d;
        if (alive) setData(d);
      })
      .catch(() => {
        // fall back silently to the static list
      });
    return () => {
      alive = false;
    };
  }, []);
  return data;
}
